import React from "react";
import Image from "next/image";
import Link from "next/link";
export const MediaCard = ({ image, date, title, link }) => {
    return (
        <Link
            href={link ? link : image}
            target="_blank"
            className="border border-[#D6D6D6] p-2 lg:p-4 rounded-[15px] bg-white block"
        >
            <div className="w-full mb-5 h-[200px] bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
                <Image
                    alt={title || "Hindustan Power media coverage"}
                    src={image}
                    width={400}
                    height={200}
                    unoptimized
                    className="max-w-full max-h-full object-contain"
                />
            </div>
            <div className="flex flex-col gap-0 items-center">
                <span className="text-[8px] lg:text-[14px] font-normal text-gray">
                    {date}
                </span>
                <h3 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-bold">
                    {title}
                </h3>
            </div>
        </Link>
    );
};